import { useRef, useState } from 'react';
import TableCell from '@mui/material/TableCell';
import {
  Badge,
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  Tooltip,
  Typography,
} from '@mui/material';
import { Mail, CommentOutlined, InfoOutlined } from '@mui/icons-material';
import MoreVert from '@mui/icons-material/MoreVert';
import Close from '@mui/icons-material/Close';
import { HeaderMoreIcon } from '../../headers/HeaderMoreIcon';
import { MenuPopover } from './MenuPopover';

export interface MailMenuCellProps {
  align?: 'left' | 'center' | 'right' | 'inherit' | 'justify' | undefined;
  cmts?: { num: number; onClick: Function };
  msgs?: { num: number; onClick: Function };
  counts?: {
    percent: number;
    [key: string]: number;
  };
  info?: {
    num: number;
    onClick: Function;
    menuItems?: { label: string; icon: JSX.Element; onClick: Function }[];
  };
  menuItems?: { tooltip: string; icon: JSX.Element; onClick: Function }[];
}

export const MailMenuCell = ({
  align,
  msgs,
  cmts,
  info,
  menuItems,
  counts,
}: MailMenuCellProps) => {
  const [menu, setMenu] = useState<boolean>(false);
  const infoRef = useRef<HTMLElement>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [hover, setHover] = useState<boolean>(false);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(infoRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'nowrap',
      }}
    >
      {cmts && cmts?.num && cmts?.num > 0 ? (
        <Box sx={{ flexBasis: 30 }}>
          <IconButton
            size="large"
            aria-label="item messages"
            edge="end"
            color="primary"
            onClick={event => {
              if (cmts?.onClick) {
                event.stopPropagation();
                event.preventDefault();
                cmts?.onClick();
              }
            }}
          >
            <Badge badgeContent={cmts?.num} color="secondary">
              <CommentOutlined color="action" />
            </Badge>
          </IconButton>
        </Box>
      ) : (
        <Box sx={{ flexBasis: 30 }}>&nbsp;</Box>
      )}
      {msgs && msgs?.num && msgs?.num > 0 ? (
        <Box sx={{ flexBasis: 30 }}>
          <IconButton
            size="large"
            aria-label="item messages"
            edge="end"
            color="primary"
            onClick={event => {
              if (msgs?.onClick) {
                event.stopPropagation();
                event.preventDefault();
                msgs?.onClick();
              }
            }}
          >
            <Badge badgeContent={msgs?.num} color="secondary">
              <Mail color="action" />
            </Badge>
          </IconButton>
        </Box>
      ) : (
        <Box sx={{ flexBasis: 30 }}>&nbsp;</Box>
      )}
      {menuItems && menuItems.length > 0 && (
        <Grid item sx={{ marginRight: '5px' }}>
          <Box
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
              setMenu(true);
            }}
          >
            <HeaderMoreIcon menuItems={menuItems as any} />
          </Box>
        </Grid>
      )}
      {counts && !Number.isNaN(counts.percent) && (
        <Tooltip title={`${counts.percent}% of items are marked complete`}>
          <Box sx={{ flexBasis: 30, pl: 2 }}>
            <Typography variant="body2">{counts.percent}%</Typography>
          </Box>
        </Tooltip>
      )}
      {info && (
        <Box sx={{ flexBasis: 30 }} ref={infoRef}>
          <MenuPopover close={() => handleClose()} menuItems={info?.menuItems}>
            {/* <Tooltip title={'Project preview'}> */}
            <IconButton
              size="large"
              aria-label="item messages"
              edge="end"
              color="primary"
              onClick={event => {
                event.stopPropagation();
                event.preventDefault();
                info.onClick();
                // handleOpen(event);
              }}
              // onMouseEnter={handleOpen}
              // onMouseLeave={handleClose}
            >
              <Badge badgeContent={info?.num} color="secondary">
                <InfoOutlined />
              </Badge>
            </IconButton>
            {/* </Tooltip> */}
          </MenuPopover>
        </Box>
      )}
    </Box>
  );
};
